<template>
  <div>
    <data-table
      :items="items"
      v-on:updateData="getLeases"
      :sortOptions="sortOptions"
      :filterOptions="filterOptions"
      :sort="sort"
      :isLoad="isLoad"
      :page="page"
      :rowsPerPage="rowsPerPage"
      :fromRow="fromRow"
      :toRow="toRow"
      :totalRows="totalRows"
      :lastPage="lastPage"
    >
      <template v-slot:header-buttons>
        <b-button
          class="ml-2"
          :to="{ name: 'leases-create' }"
          variant="primary"
        >
          <i class="lni lni-circle-plus m-0"></i>
        </b-button>
      </template>

      <template v-slot:headings>
        <div class="col-md-2">From</div>
        <div class="col-md-2">To</div>
        <div class="col-md-3">Property</div>
        <div class="col-md-2">Tenant</div>
        <div class="col-md-2">Status</div>
        <div class="col-md-1 text-left text-md-right">Action</div>
      </template>

      <template v-slot:rows="slotProps">
        <div class="col-md-2 my-auto">
          {{ moment(new Date(slotProps.item.from)).format("DD MMM YYYY") }}
        </div>

        <div class="col-md-2 my-auto">
          <span v-if="slotProps.item.type == 'fixed'">
            {{ moment(new Date(slotProps.item.to)).format("DD MMM YYYY") }}
          </span>
        </div>

        <div class="col-md-3 my-auto">
          <router-link
            v-if="slotProps.item.property"
            v-b-tooltip.hover
            title="view"
            :to="{
              name: 'properties-show',
              params: { id: slotProps.item.property.id },
            }"
            class="text-primary"
          >
            {{ slotProps.item.property.title }}
          </router-link>
        </div>

        <div class="col-md-2 my-auto">
          <router-link
            v-if="slotProps.item.tenant"
            v-b-tooltip.hover
            title="view"
            :to="{
              name: 'tenants-show',
              params: { id: slotProps.item.tenant.id },
            }"
            class="text-primary"
          >
            {{ slotProps.item.tenant.name }}
          </router-link>
        </div>

        <div class="col-md-2 my-auto">
          <p class="m-0">{{ slotProps.item.status }}</p>
        </div>

        <div class="col-md-1 my-auto text-left text-md-right pt-3 pt-md-0">
          <router-link
            v-b-tooltip.hover
            title="view"
            :to="{
              name: 'leases-show',
              params: { id: slotProps.item.id },
            }"
            class="text-info table-action-icon"
          >
            <i class="lni lni-search-alt"></i>
          </router-link>
        </div>
      </template>
    </data-table>

    <b-alert variant="info" show>
      <b-media>
        <template #aside>
          <i class="lni lni-bulb font-size-26"></i>
        </template>
        <ul>
          <li>
            Attach images to leases to document property and inventory condition
            on lease start and end .
          </li>
          <li>Attached a signed copy of a lease to lease files.</li>
        </ul>
      </b-media>
    </b-alert>

    <b-modal
      :hide-footer="true"
      :title="$route.meta.title"
      size="lg"
      v-model="sidebarToggle"
      :no-close-on-route-change="true"
      @hidden="$router.push({ name: 'leases' })"
      :lazy="true"
    >
      <router-view
        @leaseCreated="leaseCreated()"
        @leaseUpdated="leaseUpdated()"
      ></router-view>
    </b-modal>
  </div>
</template>

<script>
import leaseRepo from "@/api/repos/propertyLeaseRepo";
import dataTable from "@/components/common/DataTable";

export default {
  components: {
    dataTable: dataTable,
  },

  data() {
    return {
      sidebarToggle: false,
      isLoad: false,
      sort: { column: "to", label: "To Asc", order: "asc" },
      sortOptions: [
        { column: "to", label: "To Asc", order: "asc" },
        { column: "to", label: "To Desc", order: "desc" },
        { column: "from", label: "From Asc", order: "asc" },
        { column: "from", label: "From Desc", order: "desc" },
        { column: "created_at", label: "Date Created Asc", order: "asc" },
        { column: "created_at", label: "Date Created Desc", order: "desc" },
      ],
      filterOptions: [],
      page: 1,
      rowsPerPage: localStorage.getItem("rowsPerPage")
        ? localStorage.getItem("rowsPerPage")
        : 10,
      fromRow: 0,
      toRow: 0,
      totalRows: 0,
      lastPage: 0,
      items: [],
    };
  },
  mounted() {
    this.getLeases({
      sort: this.sort,
      filters: null,
      page: this.page,
      rowsPerPage: localStorage.getItem("rowsPerPage")
        ? localStorage.getItem("rowsPerPage")
        : 10,
      search: "",
    });
  },
  methods: {
    async getLeases(e) {
      this.isLoad = true;
      try {
        let { data } = await leaseRepo.propertyLeases(
          e.page,
          e.rowsPerPage,
          e.sort.column,
          e.sort.order,
          e.search,
          e.filters != null ? e.filters : null
        );

        this.items = data.leases.data;
        this.totalRows = data.leases.total;
        this.page = data.leases.current_page;
        this.fromRow = data.leases.from;
        this.toRow = data.leases.to;
        this.lastPage = data.leases.last_page;

        this.filterOptions = [];

        this.filterOptions.push({
          column: "status",
          value: "active",
          label: "Active",
        });

        this.filterOptions.push({
          column: "staus",
          value: "inactive",
          label: "Inactive",
        });

        this.filterOptions.push({
          column: "type",
          value: "fixed",
          label: "Fixed",
        });

        this.filterOptions.push({
          column: "type",
          value: "month to month",
          label: "Month to Month",
        });

        this.filterOptions.push({
          column: "invoice_frequency",
          value: "Daily",
          label: "Daily Invoiced",
        });

        this.filterOptions.push({
          column: "invoice_frequency",
          value: "Weekly",
          label: "Weekly Invoiced",
        });

        this.filterOptions.push({
          column: "invoice_frequency",
          value: "Monthly",
          label: "Monthly Invoiced",
        });
      } catch (error) {
        console.log(error);
      } finally {
        this.isLoad = false;
      }
    },

    leaseCreated() {
      this.$bvToast.toast("Lease Created", {
        title: "Success",
        autoHideDelay: 3000,
        variant: "success",
      });
      this.sort = {
        column: "created_at",
        label: "Date Created Desc",
        order: "desc",
      };
      this.page = 1;
      this.sidebarToggle = false;
      this.getLeases({
        sort: this.sort,
        filters: null,
        page: this.page,
        rowsPerPage: localStorage.getItem("rowsPerPage")
          ? localStorage.getItem("rowsPerPage")
          : 10,
        search: "",
      });
    },

    leaseUpdated() {
      this.$bvToast.toast("Lease Updated", {
        title: "Success",
        autoHideDelay: 3000,
        variant: "success",
      });
      this.sidebarToggle = false;
      this.getLeases({
        sort: this.sort,
        filters: null,
        page: this.page,
        rowsPerPage: localStorage.getItem("rowsPerPage")
          ? localStorage.getItem("rowsPerPage")
          : 10,
        search: "",
      });
    },
  },

  watch: {
    $route: {
      immediate: true,
      handler: function (newVal) {
        this.sidebarToggle = newVal.meta && newVal.meta.sidebarToggle;
      },
    },
  },
};
</script>
